import React, { Fragment, PureComponent } from "react";
import { CloseCircleFilled, SearchOutlined } from '@ant-design/icons';
import { Input, Popover, Select } from "antd";
import _ from 'lodash';
import '../../../../publicCss/netlist.css';
import { SPICE, TOUCHSTONE } from "../../../../constants/libraryConstants";

const Option = Select.Option;
class Port extends PureComponent {

  constructor(props) {
    super(props);
    const { pin } = props;
    this.state = {
      searchValue: "",
      selectFile: pin.model || { libraryId: "", subckt: "", port: "" },
      visible: false
    }
  }

  componentDidUpdate = (prevProps) => {
    const { pin } = this.props;
    if (!_.isEqual(pin.model || {}, prevProps.pin.model || {})) {
      this.setState({
        selectFile: pin.model || { libraryId: "", subckt: "", port: "" },
      })
    }
  }

  selectNodesFile = (key) => {
    const [libraryId, subckt] = key.split('::')
    this.setState({
      selectFile: {
        libraryId,
        subckt: subckt || "",
        port: ""
      }
    }, () => {
      const { selectFile } = this.state;
      this.props.selectOpenModel(selectFile.libraryId, selectFile.subckt)
    })
  }

  componentDidMount = () => {
    document.addEventListener('click', this.handleClickOutside, true);
    if (this.props.isTable) {
      this.initSelectFile()
    }
  }

  componentWillUnmount = () => {
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  handleClickOutside = (e) => {
    const { target } = e;
    const { pin, index, isTable } = this.props;
    const { pinName } = pin;
    const popover = document.getElementById(`${pinName}-${index}-pre-layout-popover`);
    if (!isTable && (!popover || (!popover.contains(target) && target.className !== "ant-select-item-option-content"))) {
      this.setState({
        visible: false
      })
    }
  }

  initSelectFile = (e) => {
    const { selectFile } = this.state;
    const { libraries, portsObj, lastOpenModel, modelType, pin, isTable } = this.props;
    this.openPortSelect(e)
    let _selectFile = { ...selectFile };
    if (isTable) {
      _selectFile = { ...(pin.model || {}) };
      this.setState({
        selectFile: { ..._selectFile }
      })
    }

    if (lastOpenModel && !_selectFile.libraryId) {
      const libraryIds = Object.keys(lastOpenModel);
      if (libraryIds.length) {
        const libraryId = libraryIds[0];
        const subckt = modelType === SPICE ? lastOpenModel[libraryId] || "" : "";
        const selectFile = { libraryId, subckt: subckt, port: "" };
        this.setState({
          selectFile
        })
        return
      }
    }
    if ((!_selectFile.libraryId || !libraries.find(item => _selectFile.libraryId === item.id && (modelType === TOUCHSTONE || _selectFile.subckt === item.subckt))) && libraries.length) {
      const libraryId = libraries[0].id;
      if (portsObj[libraryId] && portsObj[libraryId].length) {
        const selectFile = { libraryId: libraries[0].id, subckt: libraries[0].subckt || "", port: "" };
        this.setState({
          selectFile
        })
        if (!lastOpenModel[libraryId] && (modelType === TOUCHSTONE || libraries[0].subckt)) {
          this.props.selectOpenModel(libraryId, modelType === TOUCHSTONE ? libraryId : libraries[0].subckt)
        }
      }
    }
  }

  selectPinNode = (port) => {
    this.setState({
      selectFile: {
        ...this.state.selectFile,
        port
      },
      visible: false
    }, () => {
      const { selectFile } = this.state;
      const { pin, closePortPanel } = this.props;
      this.props.saveModel(pin, selectFile)
      closePortPanel && closePortPanel()
    })
  }

  deleteSelectNode = (e) => {
    e && e.stopPropagation();
    this.setState({
      selectFile: {
        libraryId: "",
        subckt: "",
        port: ""
      }
    }, () => {
      const { selectFile } = this.state;
      const { pin } = this.props;
      this.props.saveModel(pin, selectFile)
    })
  }

  searchNode = (e) => {
    const value = e.target.value;
    this.setState({
      searchValue: value
    })
  }

  openPortSelect = (e) => {
    e && e.stopPropagation()
    this.setState({
      visible: true
    })
  }

  blurSearch = () => {
    this.props.updateKeepFocusStatus && this.props.updateKeepFocusStatus(false)
  }

  nodeSelectRender = () => {
    const { searchValue, selectFile } = this.state;
    const { pin, libraries = [], portsObj, usedPorts, modelType, isTable } = this.props;
    const { pinName } = pin;
    const { libraryId, subckt, port } = selectFile;
    let ports = [], value = "";
    const searchReg = new RegExp(searchValue, "i");
    if (modelType === TOUCHSTONE) {
      ports = portsObj[libraryId] || [];
      ports = searchValue ? ports.filter(port => port.port.match(searchReg) || (port.info || "").match(searchReg)) : ports;
      value = libraryId || "";
    } else {
      const subckts = portsObj[libraryId] || []
      const currentSubckt = subckts.find(s => s.name === subckt);
      ports = currentSubckt ? (searchValue ? currentSubckt.ports.filter(port => port.match(searchReg)) : currentSubckt.ports) : [];
      value = libraryId && subckt ? `${libraryId}::${subckt}` : '';
    }
    return getNodeSelectRender({
      libraries,
      value,
      ports,
      pinName,
      modelType,
      usedPorts,
      searchValue,
      libraryId,
      port,
      subckt,
      isTable,
      selectNodesFile: this.selectNodesFile,
      searchNode: this.searchNode,
      selectPinNode: this.selectPinNode,
      updateKeepFocusStatus: this.props.updateKeepFocusStatus,
      blurSearch: this.blurSearch
    })
  }

  render() {
    const { pin, index, fixed, isTable } = this.props;
    const { model = {}, pinName } = pin;
    const { visible } = this.state;
    return (
      isTable ? this.nodeSelectRender()
        : <div className='spice-pin-die-value-box' id={`${pinName}-${index}-pre-layout-port`}>
          <Popover
            classNames={{ root: 'spice-port-select-Popover' }}
            content={!fixed ? this.nodeSelectRender() : null}
            title=""
            trigger="click"
            placement={"top"}
            open={visible}
            id={`${pinName}-${index}-pre-layout-popover`}
          >
            {
              model && model.port ?
                <div className='spice-pin-input' title={`${pinName} - ${model.port}`} onClick={this.openPortSelect}>
                  <span>{model.port}</span>
                  {!fixed && <CloseCircleFilled
                    className='spice-pin-node-delete-icon'
                    onClick={(e) => { this.deleteSelectNode(e) }} />}
                </div>
                : <div className='spice-pin-input port-empty-input' title={pinName} onClick={!fixed ? this.initSelectFile : null}>
                  <span>Port</span>
                </div>
            }
          </Popover>
        </div>
    );
  }
}

export function getNodeSelectRender({
  libraries,
  value,
  ports,
  pinName,
  modelType,
  usedPorts,
  searchValue,
  libraryId,
  port,
  subckt,
  selectNodesFile,
  searchNode,
  selectPinNode,
  isTable,
  updateKeepFocusStatus,
  blurSearch
}) {

  return (
    <div className='nodes-content'
      style={{ maxHeight: 400, maxWidth: 400 }}
      onMouseDown={isTable ? (e) => {
        e.preventDefault();
        e.stopPropagation();
        return false
      } : null}
    >
      {isTable ? null : <div className='nodes-content-header'>
        <span className='nodes-content-header-span'>{pinName} - Port Select</span>
      </div>}
      <div className="node-list-body-with-search">
        <div className="node-list-body-search-wrapper" onMouseDown={isTable ? (e) => {
          e.preventDefault();
          return false
        } : null}>
          <Select
            placeholder={`Select Model`}
            className='nodes-list-file-select'
            value={value}
            popupClassName='nodes-list-file-dropdown'
            popupMatchSelectWidth={false}
            onChange={selectNodesFile}
            onMouseDown={isTable ? (e) => {
              updateKeepFocusStatus && updateKeepFocusStatus(true);
              e.preventDefault();
              e.stopPropagation();
              return false
            } : null}
          >
            {libraries.map(item => (
              <Option
                key={modelType === TOUCHSTONE ? item.id : `${item.id}::${item.subckt}`}
                title={modelType === TOUCHSTONE ? item.name : `${item.name}::${item.subckt}`}
                className='spice-nodes-content-file'
                onMouseDown={isTable ? (e) => {
                  updateKeepFocusStatus && updateKeepFocusStatus(true)
                  e.preventDefault();
                  e.stopPropagation();
                  return false
                } : null}
              >
                {modelType === TOUCHSTONE ? item.name : `${item.name}::${item.subckt}`}
              </Option>
            ))
            }
          </Select>
          <Input
            placeholder={`Search Ports`}
            allowClear
            suffix={!searchValue ? <SearchOutlined style={{ color: 'rgba(0, 0, 0, .25)' }} /> : null}
            value={searchValue}
            onChange={(e) => searchNode(e)}
            onBlur={blurSearch}
            onMouseDown={isTable ? (e) => {
              updateKeepFocusStatus && updateKeepFocusStatus(true);
              e.preventDefault();
              e.stopPropagation();
              return false
            } : null}
          />
          <ul className='node-list-ul' style={{ maxHeight: 200 }}>
            {modelType === TOUCHSTONE ?
              ports.map(item => {
                const selected = usedPorts.find(used => used.libraryId === libraryId && used.port === item.port);

                return <li
                  key={item.port}
                  title={item.port}
                  className={item.port === port ? 'current-pin-selected-node-li' : (selected ? 'node-li-selected' : '')}
                  onClick={() => selected ? null : selectPinNode(item.port)}
                >
                  {item.info ? <Fragment>{item.port}&nbsp;&nbsp;&nbsp;&nbsp;{item.info}</Fragment> : item.port}
                </li>
              })
              : ports.map(item => {
                const selected = usedPorts.find(used => used.libraryId === libraryId && used.subckt === subckt && used.port === item);

                return <li
                  key={item}
                  title={item}
                  className={item === port ? 'current-pin-selected-node-li' : (selected ? 'node-li-selected' : '')}
                  onClick={() => selected ? null : selectPinNode(item)}
                >
                  {item}
                </li>
              })}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Port;